import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import FormControl from '../FormControl/FormControl.js';

const PhoneNumber = (_param)=> {
    var { label , errorMessage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "errorMessage"
    ]);
    return React.createElement(FormControl, swcHelpers.extends({}, FormControl.defaultProps, {
        id: "phone",
        "data-t": "phone-number",
        type: "tel",
        label: label,
        errorMessage: errorMessage
    }, rest));
};
var PhoneNumber$1 = PhoneNumber;

export { PhoneNumber$1 as default };
//# sourceMappingURL=PhoneNumber.js.map
